import { Dashboard } from "../dashboard"

export const WorkForceDashboard = ({pageSwap}) => {
    return(
        <Dashboard
            CustomerStage={5}
            pageSwap={pageSwap}
        />
    )
}